import Vue from "vue";

import "@/plugins/config.js";
import "@/services";
import { ENDPOINTS } from "@/services/Endpoints.js";

Vue.prototype.$pessoas_perfis = new Vue({
  data() {
    return {
      ENDPOINTS: ENDPOINTS,
      modalEvento: {
        show: false,
        text: "",
      },
      perfis: [],
      modulos: [],
      perfil_modulos: [],
      filtros: [],
      filter: {
        idperfil: "",
        descricao: "",
        loja: "",
        dataInicio: "",
        dataFim: "",
        status: "",
      },
      perfilAddOrEdit: "new",
      cadastro: {
        loading: false,
        descricao: "",
        modulo: [],
        ativo: "",
        error: {
          descricao: [],
          ativo: [],
        },
      },
    };
  },
  methods: {
    // ---- LISTAR PERFIS ---- //
    getPerfis() {
      this.cadastro.loading = true;
      this.$axios.post(this.ENDPOINTS.LISTAR_PERFIS_PESSOAS).then(response => {
        if (response) {
          this.$axios.setLocal("pessoas_perfis", response);
          this.perfis = response;
          this.cadastro.loading = false;
        }
      });
    },

    // ---- LISTAR MODULOS ---- //
    getModulos() {
      this.$axios
        .get(this.ENDPOINTS.LISTAR_MODULOS_PESSOAS + "/array")
        .then(response => {
          this.modulos = response;
          this.$axios.setLocal("pessoas_modules", response);
        });
    },

    // ---- DELETER PERFIL ---- //
    deletarPerfil(idperfil) {
      this.$axios
        .delete(this.ENDPOINTS.DELETAR_PERFIL_PESSOAS + idperfil)
        .then(response => {
          if (response) {
            document.location.reload();
          }
        });
    },

    // ---- ALTERAR PERFIL ---- //
    alterarPerfil() {
      const module = this.cadastro.modulo;
      let moduleString = [];

      module.forEach(item => {
        moduleString.push(item.key);
      });

      let dados = {
        descricao: this.cadastro.descricao,
        modulos: moduleString.join(";"),
        ativo: this.cadastro.ativo,
      };

      this.$axios
        .put(
          this.ENDPOINTS.ALTERAR_PERFIL_PESSOAS + this.cadastro.idperfil,
          dados
        )
        .then(response => {
          if (response) {
            this.$axios.setLocal("confirmEditPerfilPessoa", true);
            (this.cadastro.descricao = ""),
              (this.cadastro.ativo = ""),
              document.location.reload();
          }
        });
    },

    // ---- CADASTRAR PERFIL ---- //
    async cadastrarPerfil(modules) {
      this.cadastro.loading = true;
      // const module = this.cadastro.modulo
      let moduleString = [];

      if (modules.length > 0) {
        modules.forEach(item => {
          moduleString.push(item.key);
        });
      }

      let dados = {
        descricao: this.cadastro.descricao,
        modulos: moduleString.join(";"),
        ativo: this.cadastro.ativo,
      };

      this.$axios
        .post(this.ENDPOINTS.CADASTRAR_PERFIL_PESSOAS, dados)
        .then(response => {
          if (response) {
            (this.cadastro.descricao = ""),
              (this.cadastro.ativo = ""),
              (this.cadastro.modulo = {});
            document.location.reload();
          }
          this.cadastro.loading = false;
        })
        .catch(() => {
          this.cadastro.loading = false;
        });
    },

    filtroPerfis() {
      if (this.filter.descricao != "") {
        this.filtros.push({
          campo: "descricao",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.descricao,
        });
      } else if (this.filter.dataInicio != "") {
        this.filtros.push({
          campo: "ins_dthr",
          tipo: "date",
          orientacao: "maior",
          valor: this.filter.dataInicio + " 00:00",
        });
      } else if (this.filter.dataFim != "") {
        this.filtros.push({
          campo: "ins_dthr",
          tipo: "date",
          orientacao: "menor",
          valor: this.filter.dataFim + " 23:59",
        });
      } else {
        this.filtros = [];
      }
      let filtered = this.filtros;
      this.$axios
        .post(
          this.ENDPOINTS.LISTAR_PERFIS_PESSOAS,
          JSON.stringify({ filtros: filtered })
        )
        .then(response => {
          this.perfis = response;
        });
    },

    // ---- // ---------------------------------------- FUNÇÕES AUXILIARES ---------------------------------------- // ---- //

    // ---- FUNÇÃO QUE VALIDA O CADASTRO ---- //
    async validarCadastro(modules) {
      if (this.cadastro.descricao == "") {
        this.$config.alert(
          "Preencha a descrição do perfil!",
          this.$config.dados.errorColor
        );
        this.cadastro.error.descricao = "Preencha a descrição do perfil!";
        return;
      }

      if (this.cadastro.ativo == null) {
        this.$config.alert(
          "Selecione o status!",
          this.$config.dados.errorColor
        );
        this.cadastro.error.ativo = "Selecione o status!";
        return;
      }

      if (this.perfilAddOrEdit == "edit") {
        this.alterarPerfil();
      } else {
        this.cadastrarPerfil(modules);
      }
    },
  },
});
